import _ from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {parseApplicationUidFromType} from '../../../../../../../helpers/models/topicHelpers';
import {TopicCommentUnfurlModel} from '../../../../../../../models/api/commentUnfurlModel';
import {AppState} from '../../../../../../../store/appState';
import {getFlatApplications} from '../../../../../../../store/data/applications/applicationsSelectors';
import {getTopics} from '../../../../../../../store/data/dataSelectors';
import {getFindTeammate} from '../../../../../../../store/data/teammates/lazyTeammatesSelectors';
import {CommentViewerReferencePreviewerUnfurl} from './commentViewerReferencePreviewerUnfurl';

/*
 * Props.
 */

interface CommentViewerReferencePreviewerUnfurlContainerProps {
  unfurl: TopicCommentUnfurlModel;
  isInteractionDisabled?: boolean;
}

/*
 * Selectors.
 */

function getTopicId(_state: AppState, props: CommentViewerReferencePreviewerUnfurlContainerProps) {
  return props.unfurl.topicId;
}

function getProvidedTopic(_state: AppState, props: CommentViewerReferencePreviewerUnfurlContainerProps) {
  return props.unfurl.topic;
}

function makeGetTopic() {
  return createSelector([getTopicId, getTopics, getProvidedTopic], (topicId, topics, topic) => {
    // If we have a topic passed in, we do not need to search for it.
    if (topic) {
      return topic;
    }
    if (!topicId) {
      return undefined;
    }
    return topics[topicId];
  });
}

function makeGetTopicUnfurlOwner(getTopic: ReturnType<typeof makeGetTopic>) {
  return createSelector([getFindTeammate, getTopic], (findTeammate, topic) => {
    if (!topic?.ownerId) {
      return undefined;
    }

    return findTeammate(topic.ownerId, 'CommentViewerReferencePreviewerUnfurlContainer');
  });
}

function makeGetApplication(getTopic: ReturnType<typeof makeGetTopic>) {
  return createSelector([getTopic, getFlatApplications], (topic, applications) => {
    if (!topic) {
      return undefined;
    }

    const applicationUid = parseApplicationUidFromType(topic);
    return _(applications).find((application) => application.uid === applicationUid);
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentViewerReferencePreviewerUnfurlContainerProps>()(() => {
  const getTopic = makeGetTopic();
  return {
    topic: getTopic,
    owner: makeGetTopicUnfurlOwner(getTopic),
    application: makeGetApplication(getTopic),
  };
});

export const CommentViewerReferencePreviewerUnfurlContainer = connect(mapStateToProps)(
  CommentViewerReferencePreviewerUnfurl,
);
